import React from 'react';
import { Box, Flex, Text, IconButton } from '@chakra-ui/react';
import { Menu } from 'lucide-react';
export function Header() {
  return <Box as="header" bg="#008080" h="64px" w="100%" position="fixed" top={0} left={0} zIndex={100} boxShadow="0 2px 4px rgba(0,0,0,0.2)" data-id="element-74">
      <Flex align="center" h="100%" px={4} gap={3} data-id="element-75">
        {/* Hamburger */}
        <IconButton aria-label="Open menu" icon={<Menu size={24} color="white" data-id="element-77" />} variant="ghost" _hover={{
        bg: 'whiteAlpha.200'
      }} color="white" minW="auto" h="auto" p={1} data-id="element-76" />

        {/* Logo placeholder */}
        <Flex align="center" justify="center" w="44px" h="44px" borderRadius="md" bg="green.700" fontSize="22px" flexShrink={0} border="2px solid rgba(255,255,255,0.3)" data-id="element-78">
          🌿
        </Flex>

        {/* Title */}
        <Text color="white" fontWeight="bold" fontSize={{
        base: 'lg',
        md: 'xl',
        lg: '2xl'
      }} flex={1} textAlign="center" letterSpacing="0.01em" data-id="element-79">
          USA Dry Pea &amp; Lentil: Boards &amp; Committees
        </Text>

        {/* Spacer to balance left icons */}
        <Box w="120px" flexShrink={0} data-id="element-80" />
      </Flex>
    </Box>;
}